/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Set_New_End_Time_Last_EventInputs */

const en_set_new_end_time_last_event = /** @type {(inputs: Set_New_End_Time_Last_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set new end time of last event`)
};

const fr_set_new_end_time_last_event = /** @type {(inputs: Set_New_End_Time_Last_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Définir une nouvelle fin du dernier événement`)
};

const de_set_new_end_time_last_event = /** @type {(inputs: Set_New_End_Time_Last_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue Endzeit für das letzte Ereignis festlegen`)
};

const it_set_new_end_time_last_event = /** @type {(inputs: Set_New_End_Time_Last_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imposta una nuova ora di fine dell'ultimo evento`)
};

const ru_set_new_end_time_last_event = /** @type {(inputs: Set_New_End_Time_Last_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Установить новое время окончания последнего события`)
};

const es_set_new_end_time_last_event = /** @type {(inputs: Set_New_End_Time_Last_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Establecer nueva hora de finalización del último evento`)
};

const zh_cn2_set_new_end_time_last_event = /** @type {(inputs: Set_New_End_Time_Last_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`设置上一个事件的新结束时间`)
};

const ja_set_new_end_time_last_event = /** @type {(inputs: Set_New_End_Time_Last_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最後のイベントの新しい終了時刻を設定する`)
};

const hi_set_new_end_time_last_event = /** @type {(inputs: Set_New_End_Time_Last_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अंतिम इवेंट का नया समाप्ति समय निर्धारित करें`)
};

const pt_pt2_set_new_end_time_last_event = /** @type {(inputs: Set_New_End_Time_Last_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Defina um novo horário de término para o último evento.`)
};

/**
* | output |
* | --- |
* | "Set new end time of last event" |
*
* @param {Set_New_End_Time_Last_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const set_new_end_time_last_event = /** @type {((inputs?: Set_New_End_Time_Last_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Set_New_End_Time_Last_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_set_new_end_time_last_event(inputs)
	if (locale === "de") return de_set_new_end_time_last_event(inputs)
	if (locale === "it") return it_set_new_end_time_last_event(inputs)
	if (locale === "ru") return ru_set_new_end_time_last_event(inputs)
	if (locale === "es") return es_set_new_end_time_last_event(inputs)
	if (locale === "zh-CN") return zh_cn2_set_new_end_time_last_event(inputs)
	if (locale === "ja") return ja_set_new_end_time_last_event(inputs)
	if (locale === "hi") return hi_set_new_end_time_last_event(inputs)
	if (locale === "pt-PT") return pt_pt2_set_new_end_time_last_event(inputs)
	return en_set_new_end_time_last_event(inputs)
});